import React from 'react';
import { ShieldCheckIcon, StarIcon } from 'lucide-react';
import { CTAButton } from './CTAButton';
import { OFFER_ANCHOR, PRODUCT_IMG } from './constants';
export function Hero() {
  return <section className="bg-white px-4 pb-5 pt-4" data-id="element-79" data-mp="9kjvgl9o4y23">
      <div className="mx-auto max-w-3xl text-center" data-id="element-80" data-mp="9lbkfd8rfxje">
        <h1 className="mb-2 font-display text-[21px] font-extrabold uppercase leading-tight text-brand-ink sm:text-4xl" style={{
        fontSize: "18px"
      }} data-id="element-81" data-mp="4m8mecr76rkx">
          The Complete Installation &amp; Business System for Future Smart Home Installers
        </h1>
        <p className="mx-auto mb-2 max-w-2xl text-sm font-normal leading-snug text-brand-muted sm:text-base" style={{
        fontSize: "12px"
      }} data-id="element-82" data-mp="x8b8xs6y3h4y">
          Stop wasting hours trying to learn Smart Home installation from scattered YouTube videos,
          incomplete tutorials, outdated forums, and random online articles.
        </p>
        
        <a href={OFFER_ANCHOR} className="mb-3 block cursor-pointer" aria-label="Go to the offer" data-id="element-83" data-mp="382p9fo05jxqf">
          <img src={PRODUCT_IMG} alt="Smart Home Installer Pro complete 6-in-1 system box set" className="mx-auto w-full max-w-sm object-contain drop-shadow-2xl transition-transform duration-200 hover:scale-[1.02] sm:max-w-md" data-id="element-84" data-mp="3j8sg632wlnqw" />
        </a>
        <CTAButton className="mx-auto mb-2 max-w-md" data-id="element-85" data-mp="399tej4gk2sde">🚀 YES! I WANT MY SYSTEM NOW</CTAButton>
        <div className="flex flex-wrap items-center justify-center gap-x-4 gap-y-1 text-[11px] font-semibold text-brand-ink sm:text-sm" data-id="element-86" data-mp="3e84mtar7cuti">
          <div className="flex items-center gap-1" data-id="element-87" data-mp="30g6m9obk478y">
            <StarIcon className="h-4 w-4 fill-brand-amber text-brand-amber" data-id="element-88" data-mp="359syjfdt6948" />
            <span data-id="element-89" data-mp="2qkdai75nwhs8">⭐⭐⭐⭐⭐ 4.9/5 — Verified Student Reviews</span>
          </div>
          <span className="hidden text-brand-line sm:inline" data-id="element-90" data-mp="2viy2xkeo9x64">•</span>
          <div className="flex items-center gap-1" data-id="element-91" data-mp="2vj7s55rw80ar">
            <ShieldCheckIcon className="h-4 w-4 text-brand-orange" data-id="element-92" data-mp="2hind8kp3momj" />
            <span data-id="element-93" data-mp="2hljas7x1bbag">🛡️ 7-Day Money-Back Guarantee — Zero Risk</span>
          </div>
        </div>
      </div>
    </section>;
}